"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var bind_1 = require("../bind");
var url_helpers_1 = require("../url_helpers");
var LightboxImageItem = /** @class */ (function (_super) {
    tslib_1.__extends(LightboxImageItem, _super);
    function LightboxImageItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LightboxImageItem.prototype.isLink = function (url) {
        return url.slice(0, 4) === 'http';
    };
    LightboxImageItem.prototype.getImageURL = function () {
        var urlOrSlug = this.props.urlOrSlug;
        if (this.isLink(urlOrSlug))
            return urlOrSlug;
        return url_helpers_1.YOUTUBE_IMAGE.expand({ slug: urlOrSlug });
    };
    LightboxImageItem.prototype.handleClick = function (evt) {
        if (!this.props.onClick)
            return;
        this.props.onClick(evt, this.props.index);
    };
    LightboxImageItem.prototype.getAspectOverride = function () {
        var a = this.props.aspectOverride;
        if (!a)
            return false;
        if (a > 1)
            return 1;
        if (a < 0.5)
            return 0.5;
        return a;
    };
    LightboxImageItem.prototype.getAspectOverrideStyle = function () {
        var aspect = this.getAspectOverride();
        if (!aspect)
            return;
        return {
            style: {
                paddingBottom: aspect * 100 + "%",
            },
        };
    };
    LightboxImageItem.prototype.onLoad = function () {
        this.props.onLoad();
    };
    LightboxImageItem.prototype.render = function () {
        if (this.props.renderVideo) {
            var slug = this.props.urlOrSlug;
            return (React.createElement("div", tslib_1.__assign({ className: "lightbox-image-item", onClick: this.handleClick }, this.getAspectOverrideStyle()),
                React.createElement("div", { className: "lightbox-image-item__video-frame" },
                    React.createElement("iframe", { src: url_helpers_1.YOUTUBE_VIDEO.expand({ slug: slug, autoplay: true }), title: this.props.alt, frameBorder: "0", allowFullScreen: true }))));
        }
        return (React.createElement("div", tslib_1.__assign({ className: "lightbox-image-item", onClick: this.handleClick }, this.getAspectOverrideStyle()),
            React.createElement("img", { src: this.getImageURL(), alt: this.props.alt, onLoad: this.props.onLoad }),
            this.props.controls));
    };
    tslib_1.__decorate([
        bind_1.default
    ], LightboxImageItem.prototype, "handleClick", null);
    return LightboxImageItem;
}(React.Component));
exports.default = LightboxImageItem;
//# sourceMappingURL=lightbox_image_item.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/lightbox_image_item.js
// module id = Xyf5
// module chunks = 20 21